export const SUPPORT_URL = '/contactscustom/index/zendeskAuthentication';
export const FREE_SHIPPING = 0;
export const BRANDS_COUNT = 1500;
export const PRODUCTS_COUNT = '3 Lakhs';
